import { Box, IconButton } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear';
import { TimeSlotChip } from './TimeSlotChip'

const SloteCard = ({ day, slot, handleClear, isRemove =false , start_time,end_time }) => {
    return (
        <Box
          
            sx={{ bgcolor: "#F4F4F4", display: "flex", justifyContent: "space-between", alignItems: "center", p: "1rem", borderRadius: "10px", my: 1 }}
        >
            <Box sx={{ display: "flex", justifyContent: "start", gap: "0.5rem" }}>
                <TimeSlotChip label={day} variant='outlined' />
                <TimeSlotChip label={`${ start_time ?? slot?.start_time}-${end_time ?? slot?.end_time}`} variant='outlined' />
            </Box>
            {isRemove && <IconButton   onClick={handleClear}>
                <ClearIcon color='#A2A2A2' size={"small"} />
            </IconButton>}

        </Box>
    )
}

export default SloteCard